// extracted by mini-css-extract-plugin
export default {"encoded_link":"social-mentions-pieces-UrlDescriptorLink__encoded_link--hAlhr"};